<script lang="ts">
  import { ImageLoader, RadioTile, TileGroup } from "carbon-components-svelte";
  import type { IStampType } from "./../../ts/Interfaces";
  import { assetsURI, optionsData } from "./../../ts/Stores";

  let assetsUri: string;
  assetsURI.subscribe((value) => {
    assetsUri = value;
  });
  let values: IStampType[];
  optionsData.subscribe((optionsData) => {
    values = optionsData.canvasOptions.stampTypes;
  });

  export let selected: string;
</script>

<TileGroup bind:selected class="flex-wrap">
  {#each values as value}
    <RadioTile value={value.name}>
      <ImageLoader src="{assetsUri}/images/types/{value.image}" />
      <div>
        {value.name}
      </div>
    </RadioTile>
  {/each}
</TileGroup>
